import { Box, Typography } from '@mui/material';
import React from 'react';

/**
 * Reusable display-only field component
 * Shows a label and value in a read-only styled box
 */
function DisplayOnlyField({ label, value, wrapperClasses, error, dataCy }) {
  return (
    <Box className={wrapperClasses}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>
        {label}
      </Typography>
      <Box
        className="shadow-sm"
        sx={{
          px: 1.75,
          py: 1.75,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          minHeight: 56,
          bgcolor: 'grey.50',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
          {value || '--'}
        </Typography>
      </Box>
      {error && (
        <Typography variant="caption" className="p-1 text-red-600" data-cy={`${dataCy}-error`}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default DisplayOnlyField;
